import Instructions from './Instructions'

export * from './Instructions'

export default Instructions
